import {inputAnatomy as parts} from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import opacity from '../foundations/opacity'
import size from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(parts.keys)

const outline = definePartsStyle({
  field: {
    fontSize: typography.fontSizes.body.medium,
    spacing: spacing['5xs'],
    minW: size['4xl'],
    maxW: '1280px',
    direction: 'horizontal',
    resize: 'horizontal',
    alignItems: ['Middle', 'Left'],
    background: colors.background.primary,
    ...typography.textStyles.body.medium,
    _hover: {
      background: colors.background['primary-hover'],
    },
    _invalid: {
      borderColor: colors.border.error,
    },
    _focusVisible: {
      borderColor: colors.border.brand,
      boxShadow: 'unset',
      borderWidth: '2px',
    },
    _disabled: {
      opacity: opacity.disabled,
    },
  },
  addon: {
    bg: colors.background.secondary,
    borderColor: colors.border.primary,
    borderRadius: borders.radii['2xs'],
    textColor: colors.text.primary,
    ...typography.textStyles.body.medium,
  },
  element: {
    fill: colors.icon.primary,
  },
})

const inputSize = {
  sm: defineStyle({
    h: size.sm,
    paddingY: spacing['6xs'],
    paddingX: spacing['4xs'],
  }),
  md: defineStyle({
    h: size.md,
    paddingY: spacing['6xs'],
    paddingX: spacing['3xs'],
  }),
  xl: defineStyle({
    h: size.lg,
    paddingY: spacing['5xs'],
    paddingX: spacing.xs,
  }),
}

const sizes = {
  sm: definePartsStyle({
    field: inputSize.sm,
    addon: inputSize.sm,
  }),
  md: definePartsStyle({
    field: inputSize.md,
    addon: inputSize.md,
  }),
  xl: definePartsStyle({
    field: inputSize.xl,
    addon: inputSize.xl,
  }),
}

const inputTheme = defineMultiStyleConfig({
  variants: {outline},
  sizes,
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
})

export default inputTheme
